export default __webpack_public_path__ + "a95beac624245e24b7e7c76a74db9007.png";